import React from 'react';
import {Wrapper} from './styles';

const NoProducts = () => <Wrapper> There are no products available</Wrapper>
export default NoProducts; 